import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
import { fetchTreeList } from '@/api/system/menu/menu';
import { fetchRoleMenu, fetchCreateRoleMenu, fetchCreateRoleMenuAdmin } from '@/api/system/role/role';
export default {
  data: function data() {
    return {
      treeData: [],
      checkData: [],
      defaultData: [],
      usertype: '',
      defaultProps: {
        children: 'childMenu',
        label: 'menuName'
      }
    };
  },
  props: ['roleId', 'showDialog'],
  created: function created() {
    this.usertype = this.$store.state.user.userType;
    this.loadData();
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.treeData = [];
        this.checkData = [];

        if (this.showDialog) {
          this.loadData();
        }
      }
    }
  },
  methods: {
    loadMenuTree: function loadMenuTree() {
      var _this = this;

      var queryJson = {
        userType: this.usertype
      };
      fetchTreeList(queryJson).then(function (response) {
        _this.treeData = response.data.data;

        _this.$nextTick(function () {
          _this.checkData = _this.$refs.tree.getCheckedNodes();
        });
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      if (this.roleId > 0) {
        var data = [];
        fetchRoleMenu(this.roleId).then(function (response) {
          response.data.data.forEach(function (e) {
            data.push(e.menuId.toString());
          });
          _this2.checkData = data;

          _this2.loadMenuTree();
        });
      }
    },
    handCreate: function handCreate() {
      var _this3 = this;

      var newIdList = this.$refs.tree.getCheckedNodes(); // console.log(addIdList, this.checkData);

      var obj = {};
      var obj2 = {};
      var addIdList = [];
      var deleteIdList = [];

      var _iterator = _createForOfIteratorHelper(this.checkData),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var num = _step.value;
          obj["".concat(num['menuId'])] = "a";
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(newIdList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _num = _step2.value;

          if (!obj[_num['menuId']]) {
            addIdList.push(_num['menuId']);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(newIdList),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _num2 = _step3.value;
          obj2["".concat(_num2['menuId'])] = "a";
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var _iterator4 = _createForOfIteratorHelper(this.checkData),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _num3 = _step4.value;

          if (!obj2[_num3['menuId']]) {
            deleteIdList.push(_num3['menuId']);
          }
        } // console.log(deleteIdlist,addIdList)

      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      fetchCreateRoleMenuAdmin({
        addIdList: addIdList,
        deleteIdList: deleteIdList,
        roleId: this.roleId
      }).then(function (response) {
        _this3.$emit('handCancle', false);

        _this3.Alert({
          alertType: 'add',
          message: '角色授权成功'
        });
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};